import { cn } from '@/lib/utils'
import { type ButtonHTMLAttributes, forwardRef } from 'react'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost'
  size?: 'sm' | 'md' | 'lg'
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'primary', size = 'md', ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          'inline-flex items-center justify-center font-medium transition-all duration-fast rounded-md',
          'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          {
            // Primary - yellow
            'bg-primary text-dark hover:bg-primary-dark focus-visible:ring-primary':
              variant === 'primary',
            // Secondary - dark
            'bg-dark text-white hover:bg-dark-lighter focus-visible:ring-dark':
              variant === 'secondary',
            // Outline
            'border-2 border-primary text-primary hover:bg-primary hover:text-dark focus-visible:ring-primary':
              variant === 'outline',
            // Ghost
            'text-dark hover:bg-primary/10 focus-visible:ring-primary':
              variant === 'ghost',
          },
          {
            'px-3 py-1.5 text-sm': size === 'sm',
            'px-4 py-2 text-base': size === 'md',
            'px-6 py-3 text-lg': size === 'lg',
          },
          className
        )}
        {...props}
      />
    )
  }
)

Button.displayName = 'Button'
